import { TipologiaUtente } from "../utente/utente";

export interface RuoloDocumento {
    cognome: string,
    id: number,
    idFornitore: number,
    nome: string,
    ridp: string,
    tipologiaUtente: TipologiaUtente
}

export interface Documento {

    id: number;
    idUtenteCreazione: number;
    idUtenteUltimaModifica: number;
    dataCreazione: Date;
    dataUltimaModifica: Date;
    idOrdine: number;
    idUtente: number;
    nome: string;
    formato: string;
    idDocumentoTemp: number;
    idDocumentale: number;
    versione: number;
    idVersionePre: number;
    tipologiaDocumento: TipologiaDocumento;
    idPosizione: number;
    idFase: number;
    idNonConformita: number;
    isEliminato: boolean;
    dataEliminazione: Date;
    file: DownloadedFile[];
    numeroOrdine: string;
    codicePosizione: string;
    faseStandard: string;
    ruolo: RuoloDocumento;
}

export interface DownloadedFile {
    fileName: string;
    contentType: string;
    contentEncodedString: string;
}

export enum TipologiaDocumento {
    ADMIN = "ADMIN",
    FINAL_DATA = "FINAL_DATA",
    PED_ATEX = "PED_ATEX",
    LISTA_MATRICOLE = "LISTA_MATRICOLE",
    DISEGNI = "DISEGNI",
    ORD_ACQUISTO = "ORD_ACQUISTO",
    CERT_ISPE_REPORT = "CERT_ISPE_REPORT",
    VERBALI = "VERBALI",
    PIANO_FAB_CONTR = "PIANO_FAB_CONTR",
    PROCEDUE_ISTRUZIONI = "PROCEDUE_ISTRUZIONI",
    SICUREZZA = "SICUREZZA",
    DEVIAZIONI = "DEVIAZIONI",
    RAPPORTO_ISPETTIVO = "RAPPORTO_ISPETTIVO",
    RELAZIONE_ISPETTIVA = "RELAZIONE_ISPETTIVA",
    NON_CONFORMITA = "NON_CONFORMITA",
    CONVOCAZIONE = 'CONVOCAZIONE',
    PROGRAMMA_PROD = 'PROGRAMMA_PROD',
    FAT = 'FAT',
    CERTIFICATO_MATERIALI_NON_A_COLLAUDO = 'CERTIFICATO_MATERIALI_NON_A_COLLAUDO',
    MANUALE_USO_MANUTENZIONE = 'MANUALE_USO_MANUTENZIONE'
}